import axios from 'axios'

export default {
  addToCart (data) {
    let url = '/api/cart/update'
    const params = {}
    if (data.recommendationId && data.recommendationType) {
      params[window.advAppContext.advAppData.url.recommendationIdQuerystring] = data.recommendationId
      params[window.advAppContext.advAppData.url.recommendationTypeQuerystring] = data.recommendationType
    }

    if (data.afterAddToCartRecommendationRequest) {
      params[window.advAppContext.advAppData.url.afterAddToCartRecommendationQueryString] = data.afterAddToCartRecommendationRequest
    }

    if (Object.keys(params).length !== 0) {
      url += '?' + new URLSearchParams(params).toString()
    }

    let cartProductCustomizations = {}
    if ('cartProductCustomizations' in data) {
      cartProductCustomizations = data.cartProductCustomizations
    }
    return axios.post(url, {
      productCodeId: data.productCodeId,
      quantity: data.quantity,
      cartProductCustomizations
    }).then(response => response.data)
  },
  /**
   * @typedef {Object} CartItem
   * @property {string} productCodeId
   * @property {number} quantity
   * @property {any} cartProductCustomizations
   * @property {string|null} recommendationId
   * @property {string|null} recommendationType
   */

  /**
   * Action to add items to the cart.
   * @param {CartItem[]} data - The payload containing the items to add to the cart.
   */
  massAddToCart (data) {
    return axios.post('/api/cart/massUpdate', data).then(response => response.data)
  },
  getTransporterData (data) {
    const languageAbbr = window.advAppContext.advAppData.languageAbbr
    return axios.post(`/${languageAbbr}/api/transporters/getAvailableTransporters`, {
      country: data.country,
      county: data.county,
      postal: data.postal,
      totalWithVat: data.totalWithVat,
      weight: data.weight,
      serviceCode: data.serviceCode
    })
      .then(response => response.data)
  },
  checkCoupon (data) {
    return axios.post('/order/preview_coupon', { coupon: data }).then(response => response.data)
  },
  validateVat (data) {
    return axios.post('/order/validateVat', { country: data.country, vat: data.vat }).then(response => response.data)
  }
}
